<!--
배송단계동기화 버튼
------------------------------------
-->
<template>
  <div>
    <button
        class="uk-button uk-button-default uk-button-small"
        @click="submit"
        :disabled="offSyncState"
    >

      <span uk-icon="icon: refresh" v-show="state === 'ready'"></span>
      <span v-show="state === 'ready'">배송단계 동기화</span>


      <div class="lds-facebook" v-show="state === 'exec'"><div></div><div></div><div></div></div>
      <span v-show="state === 'exec'">처리중...</span>

    </button>

    <div v-if="displayOffSyncStateButton">
      <toggle-button
          v-model="offSyncState"
          :labels="{checked: '동기화 잠금완료', unchecked: '동기화 잠그기'}"
          :color="{checked: '#FF3232', unchecked: '#999', disabled: '#CCCCCC'}"
          :width="120"
          :height="22"
          :font-size="12"
          @change="changeOffSyncState($event)"
          :disabled="disableOffSyncState"
      />
    </div>

  </div>

</template>

<script>
    export default {
        props: {
            // csrf-token
            csrfToken: String,

            /**
             * 하우스ID
             */
            houseId: Number,

            /**
             * 배송단계API 원천사(통관사)
             */
            apiSource: {
                type: String,
                required: true,
                validator(value) {
                  // The value must match one of these strings
                  return ['acedp', 'crlogitech', 'smartlogis', 'lotos', 'bridge', 'cjdaehan', 'yuhantech', 'coship', 'mfulex'].includes(value)
                },
            },

            /**
             * 배송단계동기화 중지 버튼 표시
             */
            displayOffSyncStateButton: {
                type: Boolean,
                default: false,
            },

            /**
             * 배송단계동기화 중지 설정
             */
            initOffSyncState: {
                type: Boolean,
                default: false,
            },
        },
        data: function () {
            return {
                // 상태 : 'ready', 'exec'
                state: 'ready',

                // (bool) 배송단계동기화 중지설정
                offSyncState: this.initOffSyncState,

                // (bool) 배송단계동기화 중지 토글버튼 disabled 여부
                disableOffSyncState: false,
            };
        },
        computed: {
        },
        methods: {

            /**
             * submit
             */
            submit() {
                // 이미 처리중인지 검증
                if (this.state === 'exec') {
                    alert('처리중입니다. 잠시만 기다리세요')
                    return;
                }

                // 상태 변경
                this.state = 'exec';

                // url
                let url = null;
                if (this.apiSource === 'acedp') {
                    url = '/houses/'+this.houseId+'/acedp-state-sync';
                } else if (this.apiSource === 'crlogitech') {
                    url = '/houses/'+this.houseId+'/crlogitech-state-sync';
                } else if (this.apiSource === 'smartlogis') {
                    url = '/houses/'+this.houseId+'/smartlogis-state-sync';
                } else if (this.apiSource === 'bridge') {
                    url = '/houses/'+this.houseId+'/bridge-state-sync';
                } else if (this.apiSource === 'lotos') {
                    url = '/houses/'+this.houseId+'/lotos-state-sync';
                } else if (this.apiSource === 'cjdaehan') {
                    url = '/houses/'+this.houseId+'/cjdaehan-state-sync';
                } else if (this.apiSource === 'yuhantech') {
                    url = '/houses/'+this.houseId+'/yuhantech-state-sync';
                } else if (this.apiSource === 'coship') {
                    url = '/houses/'+this.houseId+'/coship-state-sync';
                } else if (this.apiSource === 'mfulex') {
                    url = '/houses/'+this.houseId+'/mfulex-state-sync';
                }

                // ajax 옵션
                let opts = {
                    type: 'patch',
                    url: url,
                    data: {
                        '_token': this.csrfToken,
                    },
                    success: (jqXHR, textStatus) => {
                        $.app.refresh();
                    },
                    complete: (jqXHR, textStatus) => {
                        this.state = 'ready';
                    },
                };

                // ajax 실행
                $.app.ajax.module.background(opts);
            },

            /**
             * off sync state 토글 이벤트 리스너
             */
            changeOffSyncState(obj) {
                // 토글버튼 disabled 처리
                this.disableOffSyncState = true;

                let off_sync_state = 0;
                if (obj.value) {
                    // 동기화 off
                    off_sync_state = 1;
                }

                // ajax 옵션
                let opts = {
                    type: 'patch',
                    url: '/houses/'+this.houseId+'/off-sync-state',
                    data: {
                        '_token': this.csrfToken,
                        'off_sync_state': off_sync_state,
                    },
                    complete: (jqXHR, textStatus) => {
                        $.app.refresh();
                    },
                };

                // ajax 실행
                $.app.ajax.module.background(opts);

            },
        },
    }
</script>

<style lang="scss" scoped>

    /* css loader */
    .lds-facebook {
        display: inline-block;
        position: relative;
        width: 32px;
        height: 20px;
    }
    .lds-facebook div {
        display: inline-block;
        position: absolute;
        left: 4px;
        width: 4px;
        background: #0f7ae5;
        animation: lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
    }
    .lds-facebook div:nth-child(1) {
        left: 3px;
        animation-delay: -0.24s;
    }
    .lds-facebook div:nth-child(2) {
        left: 13px;
        animation-delay: -0.12s;
    }
    .lds-facebook div:nth-child(3) {
        left: 22px;
        animation-delay: 0;
    }
    @keyframes lds-facebook {
        0% {
            top: 3px;
            height: 26px;
        }
        50%, 100% {
            top: 9px;
            height: 13px;
        }
    }


</style>